import { answerString, PatientAccessCallAnswers } from '@bariendo/lib/patient-access-note';
import {
  ADMINISTRATOR_LABELS,
  describeEmployerBenefit,
  employerAnswerIds,
  isViaFamily,
  PN_BOOK_ONCE_APPROVED_ID,
  PN_EMPLOYMENT_STATUS_ID,
  PN_FAMILY_MEMBER_NAME_ID,
} from '@bariendo/lib/pn-consultation-script';

/**
 * What the Care Coordinator needs to confirm the benefit: the employer, the
 * administrator, whose job it is, and whether the patient will book once
 * approved. Read from the answers that apply, never the raw draft.
 */
export function employerTaskDescription(answers: PatientAccessCallAnswers): string {
  const benefit = describeEmployerBenefit(answers);
  const viaFamily = isViaFamily(answers);
  const employer = answerString(answers.values[employerAnswerIds(answers).employerId]);
  const lines = [
    employer ? `Employer: ${employer}` : undefined,
    benefit?.covered ? `Administrator: ${ADMINISTRATOR_LABELS[benefit.administrator]}` : undefined,
    // The v2.0 card's employment answer, part of the verdict (BAR-2997).
    answerString(answers.values[PN_EMPLOYMENT_STATUS_ID])
      ? `Employment: ${answerString(answers.values[PN_EMPLOYMENT_STATUS_ID])}`
      : undefined,
    viaFamily
      ? `Benefits through a family member: ${answerString(answers.values[PN_FAMILY_MEMBER_NAME_ID]) ?? 'name not recorded'}`
      : undefined,
    answerString(answers.values[PN_BOOK_ONCE_APPROVED_ID])
      ? `Book once approved: ${answerString(answers.values[PN_BOOK_ONCE_APPROVED_ID])}`
      : undefined,
  ];
  return lines.filter(Boolean).join('\n');
}
